import React, { PureComponent } from "react";
import { Input } from "antd";
import "./AdminSearch.css";
import {fetchAdminSearchResults} from "./actions";
import { getSearchResults } from "./config";
import { selectHeader } from "../../../actions/globalActions";
import { connect } from "react-redux";
import { adminUsage } from "../../../utils/commonUtil";
import { encryptAccountNumber } from "../../../utils/sessionUtil";

const Search = Input.Search;

class WelcomeAdmin extends PureComponent {
  constructor(props) {
    super(props);
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    this.state = {userName: userData.username};
  }
  render() {
    return (
      <section className="">
        <h1 className="as-admin-name">Welcome {this.state.userName}</h1>
        <div className="as-admin-description">
          This is a description! This is a description! This is a description!
          This is a description! This is a description! This is a description!
          This is a description! This is a description! This is a description!
          This is a description! This is a description! This is a description!
          This is a description! This is a description!
        </div>
      </section>
    );
  }
}

class AdminSearchInput extends PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <section className="as-search-input-con">
        <div className="as-search-title">Search an account</div>
        <Search
          placeholder="Search by Account Number" 
          onChange={value => {
            this.props.onInputChange(value);
          }}
          onSearch={value => {
            this.props.searchClick(value);
          }}
          style={{ width: 200 }}
          className={this.props.errorMsg?'as-search-input-error':''}
        />
        {this.props.errorMsg &&
        <div className="as-search-error">{this.props.errorMsg}</div> }
      </section>
    );
  }
}

class AdmiSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.goToRoute = this.goToRoute.bind(this);
    this.state = { searchText: "", searchError: '' };
    adminUsage.isAdminPage = true;
    sessionStorage.setItem("isAdminPage", adminUsage.isAdminPage);
    this.searchIpErrors = {
      emptyState: "Please enter an Account number.",
      searchFailure: "Entered account number does not match any account. Please enter a valid account number.",
      noAccFound: "Could not find searched account associated to this user. Please try searching a different account number."
    }
    //sessionStorage.setItem('primaryAccount', null);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data && Object.keys(nextProps.data) && Object.keys(nextProps.data).length && !nextProps.isLoading ) {
      try {
        let searchResponse = nextProps.data;
        let primaryAccount;
        //let primaryAccount = JSON.parse(sessionStorage.getItem('primaryAccount'));
        let userData = JSON.parse(sessionStorage.getItem('userData'));
        searchResponse.username = userData.username;
        searchResponse.Accounts.forEach(function(acc) {
          acc.role.access = "Read Only";
          for (var key in acc) {
            if (key != "role" && key != "accountName" && key !="currentBalance" && key !="accountType" && key != "freezes") {
                var _encryptKey = encryptAccountNumber(key);
                acc[_encryptKey] = acc[key];
                acc["accountNumber"] = key;
                //acc["userId"] = acc[key];
                delete acc[key];
            }
          }
        });
        //userData.PrimaryAccountForParty = searchResponse.PrimaryAccountForParty;
        //userData.Accounts = searchResponse.Accounts;
        //userData = searchResponse;
        //sessionStorage.setItem('userData', JSON.stringify(searchResponse));
        
        if(searchResponse.Accounts.length > 0) {
          searchResponse.Accounts.forEach(function(acc) {
            if(Object.values(acc).some((val)=>val == searchResponse.PrimaryAccountForParty) ) {
              primaryAccount = acc;
              primaryAccount.userId = searchResponse.PrimaryAccountForParty;
              primaryAccount.accountNumber = searchResponse.accountNumber;
              // if(process.env.REACT_APP_NODE_ENV === "development") {
              //   primaryAccount.accountNumber = searchResponse.accountNumber;
              // } else {
              //   //TODO: Encrypt the account number and then store
              //   primaryAccount.accountNumber = searchResponse.accountNumber;
              // }
              sessionStorage.setItem('primaryAccount', JSON.stringify(primaryAccount));
            }
            delete acc["accountNumber"];
            delete acc["userId"];
          });
        } else {
          this.setState({ searchError: this.searchIpErrors.noAccFound });
          return;
        }
        
        sessionStorage.setItem('userData', JSON.stringify(searchResponse));
        
        adminUsage.isAdminPage = false;
        sessionStorage.setItem("isAdminPage", adminUsage.isAdminPage);
        this.setState({ searchError: "" });
        this.goToRoute("/", "ACCOUNT SUMMARY");
      } catch( error ) {
        this.setState({ searchError: this.searchIpErrors.noAccFound });
      }
      
    } else if(nextProps && nextProps.error) {
      this.setState({ searchError: this.searchIpErrors.searchFailure });
    }
  }

  goToRoute(link, SelectName) {
    this.props.selectHeader(SelectName);
    this.props.history.push(link);
  }
  handleSearch(value) {
    if (value) {
      this.setState({ searchText: value });
      // Search Api Integration has to go here
      // Below code should be in API success
      //sessionStorage.setItem('onAdminPage', false);
      this.props.fetchAdminSearchResults(getSearchResults(value));
    } else {
        this.setState({ searchError: this.searchIpErrors.emptyState });
    }
  }
  handleChange(value) {
      if(value) {
        this.setState({ searchError: "", searchText: value });
      }
  }
  render() {
    return (
      <section className="admin-search main-max-width-container">
        <WelcomeAdmin />
        <AdminSearchInput searchClick={this.handleSearch} errorMsg={this.state.searchError} onInputChange={this.handleChange} />
      </section>
    );
  }
};

export const mapStateToProps = state => {
  return {
    httpHeaders:  state.getIn(['adminSearch','adminSearchData','httpHeaders']),
    isLoading:  state.getIn(['adminSearch','adminSearchData','isLoading']),
    data:  state.getIn(['adminSearch','adminSearchData','data']),
    error: state.getIn(['adminSearch','adminSearchData','error'])
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data)),
    fetchAdminSearchResults: data => dispatch(fetchAdminSearchResults(data)) 
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdmiSearch);
